import React from 'react';
import { Modal, Box, Typography, Button, Link } from '@mui/material';

const BlockModal = ({ isOpen, onClose }) => {
    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    textAlign: 'center'
                }}
            >
                <span className="material-symbols-outlined" style={{fontSize: '3rem', color: 'var(--color-danger)', marginBottom: '1rem'}}>
                    error
                </span>
                <Typography variant="h6" gutterBottom>
                    Cuenta NO registrada
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Tu cuenta no se encuentra registrada en el sistema. Por favor, comunícate con
                    <strong> Leptón </strong> para obtener más información y contratar este servicio.
                </Typography>
                <Link
                    href="https://www.lepton-seguridad.com/"
                    target="_blank"
                    rel="noopener"
                    sx={{ display: 'block', mb: 3, color: 'primary.main', fontWeight: 'bold' }}
                >
                    Ir a la página de Leptón
                </Link>
                <Button variant="contained" color="primary" onClick={onClose}>
                    Aceptar
                </Button>
            </Box>
        </Modal>
    );
};

export default BlockModal;
